const COLOR = {
  MAIN: "#DACAFF",
  MAIN1: "#A580FC",
  MAIN2: "#AD71EA",
  MAIN3: "#FAF8FF",
  MAIN4: "#F4EFFF",
  MAINDARK: "#222222",

  ALARM: "#FF5C5C",
  YELLOW: "#F5D480",

  GRAY1: "#4E4F4E",
  GRAY2: "#7A7A7B",
  GRAY3: "#A7A7A7",
  GRAY4: "#D4D3D3",
  GRAY5: "#F5F5F5",

  WHITE: "#FFFFFF",
  BLACK: "#000000",
} as const;

export const MBTICOLOR = {
  ENFP: "#F9CAF2",
  ENFJ: "#FCE8CA",
  ENTP: "#A588FF",
  ENTJ: "#3D3DA0",
  ESFP: "#D8C8FD",
  ESFJ: "#B8C4EE",
  ESTP: "#A4B79F",
  ESTJ: "#68676B",
  INFP: "#CAFCD4",
  INFJ: "#CAEEFC",
  INTP: "#7581F2",
  INTJ: "#C6A1AE",
  ISFP: "#FFD1C5",
  ISFJ: "#4B784B",
  ISTP: "#B2A8A6",
  ISTJ: "#83899B",
} as const;

export default COLOR;
